module.exports = __webpack_public_path__ + "static/media/Apple Watch 44mm Titanium + Red Closed.5ffe34b8.png";